<template>
  <el-dialog title="打印处方笺" :visible.sync="dialogVisible" width="800px" @close="handleClose">
    <el-form
      ref="prescriptionForm"
      :model="form"
      label-width="100px"
      :rules="rules"
      label-suffix="："
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="姓名" prop="customer_name">
            <div v-if="medical_id !== ''">{{ form.customer_name }}</div>
            <el-input v-model="form.customer_name" v-else></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别" prop="customer_sex">
            <div v-if="medical_id !== ''">{{ form.customer_sex === 1 ? '男' : '女' }}</div>
            <el-radio-group v-model="form.customer_sex" v-else>
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="年龄" prop="customer_age">
            <div v-if="medical_id !== ''">{{ form.customer_age }}</div>
            <el-input placeholder="请输入年龄" v-model.number="form.customer_age" v-else></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="订单号" prop="order_no">
            {{ form.order_no }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="科别" prop="department_name">
            <div v-if="medical_id !== ''">{{ form.department_name }}</div>
            <el-input v-model="form.department_name" placeholder="请输入科别" v-else></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="开单日期" prop="deal_time">
            {{ form.deal_time }}
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="临床诊断" prop="diagnose">
        <el-input v-model="form.diagnose" type="textarea" rows="2" placeholder="请输入临床诊断"  :readonly="isDiagnoseLocked"></el-input>
      </el-form-item>

      <el-form-item label="药品明细">
        <el-table
          :data="form.goodsList"
          border
          size="mini"
          @selection-change="handleSelectionChange"
          ref="goodsTable"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
          <el-table-column label="药品名称" prop="goods_name" width="150">
            <template slot-scope="scope">
              {{ scope.row.goods_name }}
            </template>
          </el-table-column>
          <el-table-column label="规格" prop="spec_name" width="70" align="center">
            <template slot-scope="scope">
              {{ scope.row.spec_name }}
            </template>
          </el-table-column>
          <el-table-column label="数量" prop="num" width="50" align="center">
            <template slot-scope="scope">
              {{ scope.row.number }}
            </template>
          </el-table-column>
          <el-table-column label="使用方法" prop="usage">
            <template slot-scope="scope">
              <el-input v-model="scope.row.usage" type="textarea" rows="2" placeholder="请输入使用方法"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <div style="color:#999; font-size:12px; margin-top:4px">最多仅可勾选5种药品</div>
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="药费" prop="total_price">
            <el-input v-model.number="form.total_price" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="医师" prop="doctor">
            <el-input v-model="form.doctor" type="text"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="调配" prop="adjust">
            <el-input v-model="form.adjust" type="text"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="核对" prop="check">
            <el-input v-model="form.check" type="text"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="审核" prop="audit">
            <el-input v-model="form.audit" type="text"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发药" prop="dispense">
            <el-input v-model="form.dispense" type="text"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="submitForm">保存处方</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { prescriptionPrint, getDiagnose } from "@/api/order";
import { getCaseDetail } from "@/api/client";

class Form {
  order_id = "";
  customer_id = "";
  customer_name = "";
  customer_sex = "";
  customer_age = "";
  order_no = "";
  department_name = "";
  deal_time = "";
  diagnose = "";
  total_price = 0;
  doctor = "";
  adjust = "";
  check = "";
  audit = "";
  dispense = "";
  goodsList = []
}
class Rules{
  customer_name=[{ required: true, message: "请输入患者姓名", trigger: "blur" }];
  customer_sex=[{ required: true, message: "请选择性别", trigger: "change" }];
  customer_age=[{ required: true, message: "请输入年龄", trigger: "blur" }];
  department_name=[{ required: true, message: "请输入科别名称", trigger: "blur" }]; 
  diagnose=[{ required: true, message: "请填写临床诊断", trigger: "blur" }];
  total_price=[{ required: true, message: "请勾选药品自动计算药费", trigger: "blur" }];
}
export default {
  name: "OrderDialog",
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    goodsList: {
      type: Array,
      default: () => []
    },
    medical_id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isDiagnoseLocked: false,
      dialogVisible: false,
      form: new Form(),
      selectedGoods: [],
      MAX_SELECT: 5,
      rules: new Rules()
    };
  },
  watch: {
    'form.goodsList': {
      handler() {
        if (this.dialogVisible) {
          this.$nextTick(() => {
            this.selectAllGoods();
          });
        }
      },
      deep: true
    }
  },
  mounted() {
    this.form = new Form();
  },
  methods: {
    async openDialog() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.prescriptionForm) this.$refs.prescriptionForm.clearValidate();
        if (this.$refs.goodsTable) this.$refs.goodsTable.clearSelection();
        this.selectedGoods = [];
      })
      await this.fillForm();
    },
    async fillForm() {
      //
      this.form.goodsList = this.goodsList .filter(item => item.is_project == 4).map(item => ({
        goods_name: item.goods_name,
        spec_name: item.spec_name,
        number: item.number,
        pay_amount: item.pay_amount,
        kingdee_code: item.kingdee_code,
        order_goods_id: item.order_goods_id || "",
        shop_transfer_amount: item.shop_transfer_amount || 0,
        usage: item.goods_desc || ""
      }))

      this.form.order_id = this.detail.id || "";
      this.form.customer_id = this.detail.uid || "";
      this.form.customer_name = this.detail.consignee || "";
      this.form.order_no = this.detail.order_no || "";
      this.form.deal_time = this.detail.deal_time || "";
      this.form.total_price = 0;
      console.log(this.medical_id, "444");
      if (this.medical_id !== '') {
        this.isDiagnoseLocked = true;
        await this.getCaseDetail();
      } else {
        this.getDiagnose();
        this.form.customer_sex = this.detail.sex === '女' ? 2 : 1 || "";
        this.form.customer_age = this.detail.age || "";
      }
      this.$nextTick(() => {
        this.selectAllGoods();
      });
    },
    getDiagnose() {
      return getDiagnose({
        id: this.medical_id || 0,
        order_id: this.detail.id || ""
      }).then(res => {
        this.isDiagnoseLocked = !!res;
        this.form.diagnose = res || "";
      })
    },
    getCaseDetail() {
      return getCaseDetail({
        id: this.medical_id
      }).then(res => {
        this.form.customer_name = res.customer_name || "";
        this.form.customer_id = res.customer_id || "";
        this.form.customer_sex = res.customer_sex || "";
        this.form.customer_age = res.age || "";
        this.form.department_name = res.department || "";
        this.form.diagnose = res.diagnosis_str || "";
      })
    },
    handleSelectionChange(val) {
      if (val.length > this.MAX_SELECT) {
        this.$message.warning(`最多只能勾选${this.MAX_SELECT}种药品`);
        this.$refs.goodsTable.clearSelection();
        val.slice(0, this.MAX_SELECT).forEach(row => {
          this.$refs.goodsTable.toggleRowSelection(row, true);
        });
        return;
      }
      this.selectedGoods = val;
      this.calcTotal();
    },
    selectAllGoods() {
      if (!this.$refs.goodsTable || this.form.goodsList.length === 0) return;
      this.$refs.goodsTable.clearSelection();
      const list = this.form.goodsList.slice(0, this.MAX_SELECT);
      list.forEach(row => {
        this.$refs.goodsTable.toggleRowSelection(row, true);
      });
    },
    calcTotal() {
      let sum = 0;
      if (Array.isArray(this.selectedGoods)) {
        this.selectedGoods.forEach(item => {
          const pay = Number(item.pay_amount) || 0;
          const transfer = Number(item.shop_transfer_amount) || 0;
          sum += pay + transfer;
        });
      }
      this.form.total_price = Number(sum.toFixed(2));
    },
    handleClose() {
      this.dialogVisible = false;
      this.resetForm();
    },
    resetForm() {
      this.$nextTick(() => {
        if (this.$refs.prescriptionForm) this.$refs.prescriptionForm.clearValidate();
        if (this.$refs.goodsTable) this.$refs.goodsTable.clearSelection();
      });
      this.selectedGoods = [];
    },
    submitForm() {
      if (this.selectedGoods.length === 0) {
        this.$message.error("请至少勾选一种药品");
        return;
      }
      this.$refs.prescriptionForm.validate((valid) => {
        if (!valid) return;
        const submitData = {
          ...this.form,
          selectGoodsList: this.selectedGoods
        };
        console.log('提交处方数据', submitData);
        prescriptionPrint(submitData).then(res => {
          this.dialogVisible = false;
          this.$parent.getPrescriptionList()
          const route = this.$router.resolve({
            name: '处方签预览',
            query: { medical_id: res }
          })
          window.open(route.href, '_blank')
        })
      });
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
  margin-top: 20px;
}
</style>